import axios from "@/plugins/axios";
import { getSchema } from "@/schema";

export default {
  data: () => ({}),
  created: function () {},
  methods: {
    apiRequest(params = []) {
      let method = !params["method"] ? "get" : params["method"];
      let url = !params["url"] ? "/" : params["url"];
      let data = !params["payload"] ? "" : params["payload"];
      let callback = !params["callback"] ? () => {} : params["callback"];
      let callbackFinally = !params["callbackFinally"] ? () => {} : params["callbackFinally"];

      return axios({
        method,
        url,
        data,
        headers: {
          "Content-Type": "application/json;",
          "npm-call": "1",
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then((response) => {
          callback(response);
        })
        .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
        })
        .finally(callbackFinally());
    },
    setSessionData(key, value, expires) {
      const sessionObject = {
        expiresAt: expires,
        storeTime: new Date(),
        value,
      };
      sessionStorage.setItem(key, JSON.stringify(sessionObject));
    },
    getSessionData(key) {
      const sessionObject = JSON.parse(sessionStorage.getItem(key));
      if (sessionObject) {
        if (new Date() - new Date(sessionObject.storeTime) < sessionObject.expiresAt + 1000) {
          console.log(`FOUND IN SESSION KEY : [${key}]`);
          return sessionObject.value;
        }
      }
      return null;
    },
    cacheUrlList() {
      return [
        {
          url: "/account/settings/getloggedinteamrunningtests",
          time: 20000,
        },
      ];
    },
    httpRequest(method, url, data, headers = {}, controller = null) {
      if (!window?.CALL_DURATION) {
        window.CALL_DURATION = {};
      }
      if (!window?.PENDING_CALL_DURATION) {
        window.PENDING_CALL_DURATION = {};
      }
      const URL_INFO = this.cacheUrlList().find((x) => x.url === url && !window?.loadFreshData);
      const sessionData = this.getSessionData(url);
      if (typeof url === "string") {
        if (URL_INFO && sessionData) {
          return new Promise((resolve) => {
            resolve(sessionData);
          });
        }
        window.PENDING_CALL_DURATION[url] = new Date().getTime();

        return axios({
          method,
          url,
          data,
          headers,
          signal: controller?.signal ?? null,
        })
          .catch(() => {
            this.notify("Error in connection", "N");
          })
          .then((res) => {
            if (URL_INFO && res?.data) {
              this.setSessionData(url, res.data, URL_INFO.time);
            }
            if (window?.PENDING_CALL_DURATION?.[url] > 0) {
              window.CALL_DURATION[url] =
                new Date().getTime() - (window?.PENDING_CALL_DURATION?.[url] ?? 0);
            }
            return res?.data ?? {};
          });
      } else {
        return new Promise((resolve, reject) => {
          reject(`httpRequest: url is not a string : ${url}`);
        });
      }
    },
    POST(url, data = {}) {
      const _data = {
        ...data,
        CSRFToken: this.$store.state.window.CSRFToken,
      };
      return this.httpRequest("POST", url, this.formData(_data), { withCredentials: true });
    },
    J_POST(url, data = {}, controller = null) {
      const _data = {
        ...data,
        CSRFToken: this.$store.state.window.CSRFToken,
      };
      const headers = {
        "Content-Type": "application/json;",
        "npm-call": "1",
        "X-Requested-With": data?.external ? null : "XMLHttpRequest",
        withCredentials: data?.external ? false : true,
      };
      if (data?.external) {
        headers["X-CSRF-Token"] = this.$store.state.window.CSRFToken;
        delete _data.CSRFToken;
        delete headers["npm-call"];
      }
      return this.httpRequest("POST", url, _data, headers, controller);
      // .then((data) => {
      //   if (typeof data === "object") {
      //     if (data?.actionResult === "ERROR") {
      //       this.checkForError(data);
      //     }
      //   }
      //   return data;
      // });
    },
    validateSchema(schema, response) {
      let errors = {};
      Object.entries(schema).forEach(([key, value]) => {
        if (value.type) {
          const dataType = typeof response[key];
          if (value.type === "number") {
            if (dataType !== "number") {
              errors[key] = `Invalid type :: Expected Number but received ${dataType}`;
              errors[key + ":value"] = response[key];
            }
          } else if (value.type === "string") {
            if (dataType !== "string") {
              errors[key] = `Invalid type :: Expected String but received ${dataType}`;
              errors[key + ":value"] = response[key];
            }
          } else if (value.type === "object") {
            if (dataType !== "object") {
              errors[key] = `Invalid type :: Expected Object but received ${dataType}`;
              errors[key + ":value"] = response[key];
            }
            if (Array.isArray(response?.[key])) {
              errors[key] = "Invalid type :: Expected Object but received Array";
              errors[key + ":value"] = response[key];
            }
          } else if (value.type === "array") {
            if (Array.isArray(response[key]) !== true) {
              errors[key] = `Invalid type :: Expected Array but received ${dataType}`;
              errors[key + ":value"] = response[key];
            } else {
              if (value?.child) {
                response[key].find((el) => {
                  const childErrors = this.validateSchema(value.child, el ?? {});
                  if (Object.keys(childErrors).length > 0) {
                    errors[key] = childErrors;
                    return true;
                  }
                });
              }
            }
          } else if (value.type === "boolean") {
            if (dataType !== "boolean") {
              errors[key] = `Invalid type expected Boolean but received ${dataType}`;
              errors[key + ":value"] = response[key];
            }
          }
        } else {
          const childErrors = this.validateSchema(value, response?.[key] ?? {});
          if (Object.keys(childErrors).length > 0) {
            errors[key] = childErrors;
            errors[key + ":value"] = response;
          }
        }
      });
      return errors;
    },
    post(url, data = {}, developer = "", controller = null) {
      const _data = {
        ...data,
        CSRFToken: this.$store.state.window.CSRFToken,
      };
      return this.httpRequest(
        "POST",
        url,
        _data,
        {
          "Content-Type": "application/json;",
          "npm-call": "1",
          "X-Requested-With": "XMLHttpRequest",
          withCredentials: true,
        },
        (controller = null)
      ).then((data) => {
        let errors = {};
        const schema = getSchema(url);
        if (schema) {
          errors = this.validateSchema(schema, data);
        } else {
          errors = {
            ...errors,
            Scheme: `Invalid Scheme :: Expected Object Schema but received ${typeof data}`,
          };
        }
        const schemaPayload = { ..._data };
        delete schemaPayload.CSRFToken;
        schemaPayload.extrainfo = "------- Extra INFO BELOW ---------";
        schemaPayload.team_id = this.$store.state.window.team_id;
        schemaPayload.user_id = this.$store.state.window.user_id;
        schemaPayload.tester = this.$store.state.window.is_user_tester;

        if (
          Object.keys(errors).length > 0 &&
          ["release", "dev", "ashvinijdev", "chetanysdev"].includes(this.$store.state.window.mode)
        ) {
          console.log(`Schema Validation Failed : ${url}`, errors);
        }

        return data;
      });
    },
    GET(url, data = {}, headers = {}, controller = null) {
      return this.httpRequest(
        "get",
        url,
        data,
        {
          ...headers,
          withCredentials: true,
          "npm-call": 1,
        },
        (controller = null)
      );
    },
    J_GET(url, data = {}) {
      return this.httpRequest("get", url, data, {
        "Content-Type": "application/json;",
        "npm-call": "1",
        "X-Requested-With": "XMLHttpRequest",
        withCredentials: true,
      });
    },
    fetch(url, data = {}) {
      return fetch(url, data).then((d) => d.json());
    },
    // checkSiteFileRestriction(uploadedimagename) {
    //   console.log("imajnaa0")
    //   if (window.site_id && window.is_file_restriction == "1") {
    //     var allowed_file_extensions_lower = window.allowed_file_extensions.toLowerCase();
    //     var fileExtension = uploadedimagename.toString().split(".").slice(-1);
    //     if (!allowed_file_extensions_lower.split(",").includes(fileExtension[0].toLowerCase())) {
    //       this.$refs?.uploader?.reset();
    //       this.$toast.error(
    //         "This file type has been restricted for upload. Please contact the site administrator for permissions."
    //       );
    //       return false;
    //     }
    //   }
    //   return true;
    // }
  },
};
